import React, { useState, useEffect } from 'react';
import { apiRaw } from '../../../api';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CitasTalleres.css';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { fetchUsuario, getUsuario } from '../../user';
import Select from 'react-select';
import baseURL from '../../url';
import Helper from '../../../Helpers/helpers';
import AsyncSelect from 'react-select/async';

import TurnoModalTaller from '../../Modals/TurnoModalTaller';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// Configuración de moment.js
moment.locale('es');
const localizer = momentLocalizer(moment);

// Mensajes en español para las vistas
const messages = {
    today: 'Hoy',
    previous: 'Anterior',
    next: 'Siguiente',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Evento',
};




export default function CitasTalleres() {
    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const [loading, setLoading] = useState(true);

    const turnos = []; // turnos_talleres (tabla eliminada) — feature retirada
    const [sesiones, setSesiones] = useState([]); // Nuevo estado para sesiones
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
    const [sesionSeleccionada, setSesionSeleccionada] = useState(null); // Nueva para sesiones
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [nombre, setNombre] = useState("");
    const [telefono, setTelefono] = useState("");

    const [nuevaFecha, setNuevaFecha] = useState("");
    const [periodicidad, setPeriodicidad] = useState("");

    const [nuevaHoraInicio, setNuevaHoraInicio] = useState("");
    const [nuevaHoraFin, setNuevaHoraFin] = useState("");

    const [nuevoComentario, setNuevoComentario] = useState("");

    const [cancelarActualizado, setCancelarActualizado] = useState(0); //se usa para saber cuando se hizo una cancelacion

    const [nuevoEstado, setNuevoEstado] = useState('');
    const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [selectedEstados, setSelectedEstados] = useState(['pendiente', 'aprobado', 'aprobado_oculto']); // Por default: todos los estados de aprobación
    const [terapeutaSeleccionado, setTerapeutaSeleccionado] = useState('');
    const [salas, setSalas] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [salaSeleccionada, setSalaSeleccionada] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [categoriaFiltrada, setCategoriaFiltrada] = useState(null);

    const [categoriasFiltradas, setCategoriasFiltradas] = useState([]);

    const [citasSeleccionadas, setCitasSeleccionadas] = useState([]); //seleccionadas para cancelarse

    useEffect(() => {
        cargarSesionesTalleres();
        cargarSalas();
        cargarCategorias();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();

    useEffect(() => {
        if (usuarioLegued?.rol === 'terapeuta' &&
            usuarioLegued?.idCategorias &&
            usuarioLegued.idCategorias.length > 0 &&
            categorias.length > 0 &&
            !categoriaFiltrada) {
            const cesecoPrincipal = categorias.find(cat =>
                cat.idCategoria === usuarioLegued.idCategoria ||
                (usuarioLegued.cesecoPrincipal && cat.idCategoria === usuarioLegued.cesecoPrincipal.idCategoria)
            );
            if (cesecoPrincipal) {
                setCategoriaFiltrada({ value: cesecoPrincipal.idCategoria, label: cesecoPrincipal.categoria });
            }
        }
    }, [categorias.length, usuarioLegued?.idCategorias?.length, usuarioLegued?.idCategoria]);

    useEffect(() => {
        if (!usuarioLegued || serviciosFiltrados.length > 0 || !sesiones.length) return;
        if (['terapeuta', 'coord_programa'].includes(usuarioLegued?.rol) && Array.isArray(usuarioLegued?.idServicios)) {
            const serviciosDisponibles = sesiones
                .filter(sesion => usuarioLegued.idServicios.includes(sesion.idPrograma))
                .reduce((acc, sesion) => {
                    if (!sesion.idPrograma || !sesion.nombrePrograma) return acc;
                    if (acc.some(item => String(item.value) === String(sesion.idPrograma))) return acc;
                    acc.push({ value: sesion.idPrograma, label: sesion.nombrePrograma });
                    return acc;
                }, []);
            if (serviciosDisponibles.length > 0) {
                setServiciosFiltrados(serviciosDisponibles);
            }
        }
    }, [sesiones.length, usuarioLegued?.idServicios?.length, usuarioLegued?.rol, serviciosFiltrados.length]);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoEstado(turnoSeleccionado?.estado);
    }, [turnoSeleccionado]);

    const cargarSesionesTalleres = () => {
        return apiRaw(`/talleres/sesiones/calendario`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    console.error('Error al cargar sesiones:', data.error);
                    setSesiones([]);
                    return [];
                }
                
                const sesionesData = data.sesiones || [];
                console.log('Sesiones cargadas:', sesionesData);
                setSesiones(sesionesData);
                return sesionesData;
            })
            .catch(error => {
                console.error('Error al cargar sesiones de talleres:', error);
                setSesiones([]);
                return [];
            });
    }

    const cargarTurnos = () => Promise.resolve([]); // feature retirada (turnos_talleres)

    const cargarSalas = () => {
        apiRaw(`/salas`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSalas(data.salas || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarCategorias = () => {
        apiRaw(`/categorias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const normalizarTexto = (value) => (value || '').toString().toLowerCase();

    const sesionDentroDeAsignaciones = (sesion) => {
        if (['admin', 'direccion'].includes(usuarioLegued?.rol)) return true;
        if (usuarioLegued?.rol === 'terapeuta') {
            return String(sesion.idTerapeuta) === String(usuarioLegued?.idUsuario);
        }
        if (['coord_programa'].includes(usuarioLegued?.rol)) {
            return usuarioLegued?.idServicios?.includes(Number(sesion.idPrograma));
        }
        if (['coord_ceseco', 'secretaria'].includes(usuarioLegued?.rol)) {
            return usuarioLegued?.idCategorias?.includes(Number(sesion.idCategoria));
        }
        return true;
    };

    const sesionesFiltradas = (sesiones || []).filter(sesion => {
        const texto = normalizarTexto(filterText).trim();
        const coincideTexto = !texto || [
            sesion.nombreTaller,
            sesion.nombrePrograma,
            sesion.nombreCeseco,
            sesion.nombreTerapeuta
        ].some(valor => normalizarTexto(valor).includes(texto));

        const coincideCeseco = !categoriaFiltrada ||
            String(sesion.idCategoria) === String(categoriaFiltrada.value);

        const coincidePrograma = serviciosFiltrados.length === 0 ||
            serviciosFiltrados.some(servicio => String(servicio.value) === String(sesion.idPrograma));

        const coincideEstado = selectedEstados.length === 0 ||
            selectedEstados.includes(sesion.estadoAprobacion);

        return sesionDentroDeAsignaciones(sesion) && coincideTexto && coincideCeseco && coincidePrograma && coincideEstado;
    });

    const sesionesParaProgramas = categoriaFiltrada
        ? sesiones.filter(sesion => String(sesion.idCategoria) === String(categoriaFiltrada.value))
        : sesiones;

    const opcionesCeseco = categorias
        .filter(cat => sesiones.some(sesion => String(sesion.idCategoria) === String(cat.idCategoria)))
        .filter(cat => {
            if (['admin', 'direccion'].includes(usuarioLegued?.rol)) return true;
            return usuarioLegued?.idCategorias?.includes(Number(cat.idCategoria));
        })
        .map(cat => ({ value: cat.idCategoria, label: cat.categoria }));

    const opcionesProgramas = sesionesParaProgramas
        .reduce((acc, sesion) => {
            if (!sesion.idPrograma || !sesion.nombrePrograma) return acc;
            if (acc.some(item => String(item.value) === String(sesion.idPrograma))) return acc;
            acc.push({ value: sesion.idPrograma, label: sesion.nombrePrograma });
            return acc;
        }, [])
        .filter(programa => {
            if (['admin', 'direccion'].includes(usuarioLegued?.rol)) return true;
            if (usuarioLegued?.rol === 'terapeuta' || usuarioLegued?.rol === 'coord_programa') {
                return usuarioLegued?.idServicios?.includes(Number(programa.value));
            }
            return true;
        });


    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <FontAwesomeIcon icon={faSpinner} spin size="2x" className="me-2" />
                <span>Cargando talleres...</span>
            </div>
        );
    }

    const handleSelectEvent = (event) => {
        // Si el evento tiene idSesion, es una sesión de taller
        if (event.idSesion) {
            const sesionSeleccionada = sesiones.find(item => item.idSesion === event.idSesion);
            
            if (sesionSeleccionada) {
                setModalIsOpen(true);
                setSesionSeleccionada(sesionSeleccionada);
                
                // Crear un objeto compatible con el modal existente
                const turnoCompatible = {
                    idTaller: sesionSeleccionada.idTaller,
                    nombreTaller: sesionSeleccionada.nombreTaller,
                    fecha: sesionSeleccionada.fecha,
                    horaInicio: sesionSeleccionada.horaInicio,
                    horaFin: sesionSeleccionada.horaFin,
                    idSesion: sesionSeleccionada.idSesion,
                    numeroSesion: sesionSeleccionada.numeroSesion,
                    totalSesiones: sesionSeleccionada.totalSesiones,
                    inscritos: sesionSeleccionada.inscritos,
                    cupoMax: sesionSeleccionada.cupoMax,
                    disponibles: sesionSeleccionada.disponibles,
                    idTerapeuta: sesionSeleccionada.idTerapeuta,
                    nombreTerapeuta: sesionSeleccionada.nombreTerapeuta,
                    idSala: sesionSeleccionada.idSala,
                    nombreSala: sesionSeleccionada.nombreSala,
                    nombrePrograma: sesionSeleccionada.nombrePrograma,
                    nombreCeseco: sesionSeleccionada.nombreCeseco,
                    // Campos esperados por el modal
                    servicio: sesionSeleccionada.nombrePrograma, // El modal espera 'servicio'
                    nombreCategoria: sesionSeleccionada.nombreCeseco, // El modal espera 'nombreCategoria'
                    idCategoria: sesionSeleccionada.idCategoria,
                    idPrograma: sesionSeleccionada.idPrograma,
                    // Simular formato de dias para compatibilidad con modal
                    dias: [{
                        dia: sesionSeleccionada.fecha,
                        horaInicio: sesionSeleccionada.horaInicio.substring(0, 5),
                        horaFin: sesionSeleccionada.horaFin.substring(0, 5)
                    }]
                };
                
                setTurnoSeleccionado(turnoCompatible);
                setTerapeutaSeleccionado(sesionSeleccionada.idTerapeuta);
                setSalaSeleccionada(sesionSeleccionada.idSala);
                console.log('Sesión seleccionada:', turnoCompatible);
            }
        } else {
            // Fallback para inscripciones individuales (si todavía existen)
            const turnoSeleccionado = turnos.find(item => item.idTurno === event.idTurno);

            if (turnoSeleccionado) {
                setModalIsOpen(true);
                setTurnoSeleccionado(turnoSeleccionado);
                setTerapeutaSeleccionado(turnoSeleccionado.idTerapeutaAsignado);
                setSalaSeleccionada(turnoSeleccionado.idSala);
                console.log(turnoSeleccionado);
            }
        }
    };

    const handleCloseModal = () => {
        setModalIsOpen(false); // Cerrar el modal
    };

    // Handlers de 'turnos_talleres' (tabla eliminada) — retirados; muestran aviso.
    const _tallerFeatureRetirada = () => Swal.fire('No disponible', 'La gestión de citas de taller del modelo anterior fue retirada. Usa inscripciones a sesiones.', 'info');
    const handleUpdateText = () => _tallerFeatureRetirada();
    const handleUpdateDate = () => _tallerFeatureRetirada();
    const handleNewAppointment = () => _tallerFeatureRetirada();
    const handleCancelar = () => _tallerFeatureRetirada();


    // Primero filtramos por categorías y acceso
    const turnosFiltrados = turnos?.filter(turno => {
        const pasaFiltroCategorias = categoriasFiltradas.length === 0 ||
            categoriasFiltradas.map(categoria => categoria.value).includes(turno?.idCategoriaSala);

        if ((usuarioLegued?.rol === 'coord_ceseco' ||
            usuarioLegued?.rol === 'coord_programa' ||
            usuarioLegued?.rol === 'secretaria') &&
            serviciosFiltrados.length === 0 && categoriasFiltradas.length === 0) {
            const tieneAcceso = usuarioLegued?.idCategorias?.includes(turno?.idCategoria) ||
                turno?.idCategoria === usuarioLegued?.idCategoria;
            return tieneAcceso;
        }

        return pasaFiltroCategorias;
    }) || [];

    // Luego aplicamos el filtro de estados de manera segura
    const filteredTurnos = (() => {
        // Si no hay estados seleccionados, devolvemos todos los turnos filtrados
        if (!selectedEstados || selectedEstados.length === 0) {
            return turnosFiltrados;
        }

        // Mapeo de estados a funciones de filtrado
        const estadosMap = {
            pendiente: (turno) => turno.estado?.toLowerCase() === 'pendiente',
            asignado: (turno) => turno.estado?.toLowerCase() === 'asignado',
            finalizado: (turno) => turno.estado?.toLowerCase() === 'finalizado',
            inactivo: (turno) => turno.estado?.toLowerCase() === 'inactivo',
        };

        // Filtramos los turnos según los estados seleccionados
        return turnosFiltrados.filter(turno => {
            // Verificamos si el estado del turno coincide con alguno de los estados seleccionados
            return selectedEstados.some(estado => {
                const filterFn = estadosMap[estado.toLowerCase()];
                return filterFn ? filterFn(turno) : false;
            });
        });
    })();

    const CustomEvent = ({ event }) => {
        const horaInicio = moment(event.start).format('HH:mm');
        const horaFin = moment(event.end).format('HH:mm');
        const color = event.style?.color || 'black';
        
        // Si es una sesión de taller, mostrar información diferente
        if (event.idSesion) {
            return (
                <div style={{ whiteSpace: 'normal', color }}>
                    <div style={{ fontSize: '0.85em', fontWeight: 'bold' }}>
                        {event.title}
                    </div>
                    <div style={{ fontSize: '0.75em' }}>
                        Sesión {event.numeroSesion}/{event.totalSesiones}
                    </div>
                    <div style={{ fontSize: '0.75em' }}>
                        {horaInicio} - {horaFin}
                    </div>
                    <div style={{ fontSize: '0.75em' }}>
                        {event.inscritos}/{event.cupoMax} inscritos
                    </div>
                </div>
            );
        }
        
        // Formato original para inscripciones individuales
        return (
            <div style={{ whiteSpace: 'normal', color }}>
                <div style={{ fontSize: '0.8em' }}>
                    Inscritos:{event.totalInscritos}
                </div>
                <div style={{ fontSize: '0.8em' }}>
                    {horaInicio} - {horaFin}
                </div>
                <div style={{ fontSize: '0.8em' }}>
                    <strong>{event.title}</strong>
                </div>
                <div style={{ fontSize: '0.8em' }}>
                    <strong>{event.taller}</strong>
                </div>
            </div>
        );
    };

    // Convertir sesiones a eventos del calendario
    const eventosSesiones = sesionesFiltradas.map(sesion => {
        // Determinar color según estado de aprobación
        let backgroundColor, color;
        switch (sesion.estadoAprobacion) {
            case 'pendiente':
                backgroundColor = '#f0f0f0';
                color = '#666';
                break;
            case 'aprobado':
                backgroundColor = '#e6f9ed';
                color = '#1a7f37';
                break;
            case 'aprobado_oculto':
                backgroundColor = '#bee4fa';
                color = '#386def';
                break;
            default:
                backgroundColor = '#bee4fa';
                color = '#386def';
        }

        return {
            title: sesion.nombreTaller,
            start: new Date(`${sesion.fecha}T${sesion.horaInicio}`),
            end: new Date(`${sesion.fecha}T${sesion.horaFin}`),
            allDay: false,
            idSesion: sesion.idSesion,
            idTaller: sesion.idTaller,
            numeroSesion: sesion.numeroSesion,
            totalSesiones: sesion.totalSesiones,
            inscritos: sesion.inscritos,
            cupoMax: sesion.cupoMax,
            disponibles: sesion.disponibles,
            style: { backgroundColor, color },
        };
    });

    // Mantener eventos de turnos individuales (por si todavía existen)
    const eventosTurnos = turnos
        .map(item => {
            const dias = item.dias ?? [];
            return dias?.map(dia => {
                const colors = Helper.getTurnoColors(item);

                return {
                    title: `${item.nombreTaller}`,
                    start: new Date(dia.dia + "T" + dia.horaInicio),
                    end: new Date(dia.dia + "T" + dia.horaFin),
                    allDay: false,
                    idTurno: item.idTurno,
                    estado: item.estado,
                    taller: item.servicio,
                    totalInscritos: item.totalInscritos,
                    style: { backgroundColor: colors[0], color: colors[1] },
                };
            });
        })
        .flat() ?? [];

    // Combinar eventos de sesiones y turnos
    const events = [...eventosSesiones, ...eventosTurnos];



    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color1 : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
            ...provided,
            maxHeight: '32px',
            overflowY: 'auto',
            paddingRight: '30px',
            borderRadius: '8px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '8px',

        }),
        clearIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '20px',
            top: '2px',
            zIndex: 1,
            width: '50px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '-5px',
            top: '2px',
            zIndex: 1,
        }),
    };


    return (
        <div className="container-fluid p-4">
            <div className="card shadow-sm">
                <div className="card-header bg-white py-3">
                    <div className="d-flex justify-content-between align-items-center">
                        {/* Leyenda de colores para los estados de aprobación de talleres */}
                        <div className="turnos-legend" style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#f0f0f0', border: '1px solid #999' }}></span>
                                <span>Pendiente</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#e6f9ed', border: '1px solid #1a7f37' }}></span>
                                <span>Aprobado</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#bee4fa', border: '1px solid #386def' }}></span>
                                <span>Aprobado (Oculto)</span>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card-body p-0">
                    {/* Badge mostrando Ceseco y Programa asignados */}
                    {usuarioLegued?.idUsuario && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.75rem',
                            padding: '0.5rem 0.75rem',
                            background: '#f8f9fa',
                            borderRadius: '6px',
                            border: '1px solid #e9ecef',
                            fontSize: '0.875rem',
                            color: '#495057',
                            margin: '1rem',
                            maxWidth: 'fit-content',
                            flexWrap: 'wrap'
                        }}>
                            <span style={{ fontSize: '0.875rem', color: '#6c757d', fontWeight: 500 }}>Ceseco:</span>
                            <span style={{ fontWeight: 600, color: '#212529' }}>
                                {usuarioLegued?.categorias && usuarioLegued.categorias.length > 0
                                    ? usuarioLegued.categorias.map(c => c.categoria).join(', ')
                                    : (usuarioLegued?.categoria ||
                                       categorias.find(cat => cat.idCategoria === usuarioLegued?.idCategoria)?.categoria ||
                                       'Sin asignar')}
                            </span>
                            <span style={{ fontSize: '0.875rem', color: '#6c757d', fontWeight: 500 }}>Programa:</span>
                            <span style={{ fontWeight: 600, color: '#212529' }}>
                                {serviciosFiltrados.length > 0
                                    ? serviciosFiltrados.map(s => s.label).join(', ')
                                    : (sesionesFiltradas.length > 0
                                        ? [...new Set(sesionesFiltradas.map(s => s.nombrePrograma).filter(Boolean))].join(', ')
                                        : (usuarioLegued?.servicios && usuarioLegued.servicios.length > 0
                                            ? usuarioLegued.servicios.map(s => s.titulo).join(', ')
                                            : 'Sin asignar'))}
                            </span>
                        </div>
                    )}
                    <div className="grapBtns" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap', margin: '1rem' }}>
                        <div style={{ minWidth: 280 }}>
                            <input
                                type="text"
                                placeholder="Buscar por taller, Ceseco, terapeuta o programa"
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '0.5rem 0.75rem',
                                    border: '1px solid #ccc',
                                    borderRadius: 8
                                }}
                            />
                        </div>
                        {usuarioLegued?.rol === 'terapeuta' && (
                            <>
                                {usuarioLegued?.idCategorias && usuarioLegued.idCategorias.length > 1 && (
                                    <div style={{ minWidth: 260 }}>
                                        <Select
                                            options={opcionesCeseco}
                                            value={categoriaFiltrada}
                                            onChange={(selected) => setCategoriaFiltrada(selected)}
                                            placeholder="Filtrar por Ceseco"
                                            isClearable
                                            styles={customStyles}
                                            maxMenuHeight={350}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuShouldBlockScroll={true}
                                        />
                                    </div>
                                )}
                                <div style={{ minWidth: 280 }}>
                                    <Select
                                        isMulti
                                        options={opcionesProgramas}
                                        value={serviciosFiltrados}
                                        onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions || [])}
                                        styles={customStyles}
                                        placeholder="Programas"
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        maxMenuHeight={350}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        menuShouldBlockScroll={true}
                                    />
                                </div>
                                {(filterText || categoriaFiltrada || serviciosFiltrados.length > 0) && (
                                    <button
                                        className="btnNoSelected"
                                        onClick={() => {
                                            setFilterText('');
                                            setCategoriaFiltrada(null);
                                            setServiciosFiltrados([]);
                                        }}
                                        style={{ border: '1px solid #ea4b29', color: '#ea4b29' }}
                                    >
                                        Quitar Filtros
                                    </button>
                                )}
                            </>
                        )}
                        {usuarioLegued?.rol === 'coord_programa' && (
                            <>
                                {(() => {
                                    const serviciosAsignados = usuarioLegued?.idServicios || (usuarioLegued?.idServicio ? [usuarioLegued.idServicio] : []);
                                    const cesecosDeServicios = sesiones
                                        .filter(sesion => serviciosAsignados.includes(sesion.idPrograma))
                                        .map(sesion => sesion.idCategoria);
                                    const cesecosUnicos = [...new Set(cesecosDeServicios)];
                                    return cesecosUnicos.length > 1 ? (
                                        <div style={{ minWidth: 260 }}>
                                            <Select
                                                options={opcionesCeseco.filter(cat => cesecosUnicos.includes(cat.value))}
                                                value={categoriaFiltrada}
                                                onChange={(selected) => setCategoriaFiltrada(selected)}
                                                placeholder="Filtrar por Ceseco"
                                                isClearable
                                                styles={customStyles}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    ) : null;
                                })()}
                                <div style={{ minWidth: 280 }}>
                                    <Select
                                        isMulti
                                        options={opcionesProgramas}
                                        value={serviciosFiltrados}
                                        onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions || [])}
                                        styles={customStyles}
                                        placeholder="Programas"
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        maxMenuHeight={350}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        menuShouldBlockScroll={true}
                                    />
                                </div>
                                {(filterText || categoriaFiltrada || serviciosFiltrados.length > 0) && (
                                    <button
                                        className="btnNoSelected"
                                        onClick={() => {
                                            setFilterText('');
                                            setCategoriaFiltrada(null);
                                            setServiciosFiltrados([]);
                                        }}
                                        style={{ border: '1px solid #ea4b29', color: '#ea4b29' }}
                                    >
                                        Quitar Filtros
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                    {(categoriaFiltrada || serviciosFiltrados.length > 0) && (
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.75rem',
                            marginBottom: '1rem',
                            padding: '0.75rem 1rem',
                            marginLeft: '1rem',
                            marginRight: '1rem',
                            background: '#f8f9fa',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef'
                        }}>
                            {categoriaFiltrada && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '0.5rem 0.75rem',
                                    background: '#e7f3ff',
                                    borderRadius: '6px',
                                    fontSize: '0.875rem'
                                }}>
                                    <span style={{ fontWeight: 600, color: '#0066cc' }}>Ceseco:</span>
                                    <span style={{ color: '#333' }}>{categoriaFiltrada.label}</span>
                                </div>
                            )}
                            {serviciosFiltrados.length > 0 && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '0.5rem 0.75rem',
                                    background: '#fff3cd',
                                    borderRadius: '6px',
                                    fontSize: '0.875rem'
                                }}>
                                    <span style={{ fontWeight: 600, color: '#856404' }}>Programas:</span>
                                    <span style={{ color: '#333' }}>{serviciosFiltrados.map(s => s.label).join(', ')}</span>
                                </div>
                            )}
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: '0.5rem', marginLeft: '1rem', marginBottom: '1rem' }}>
                        {Helper.estadoFiltrosTalleres.map(filtro => (
                            <button
                                key={filtro.key}
                                className={selectedEstados.includes(filtro.key) ? 'btnSelected' : 'btnNoSelected'}
                                style={{
                                    background: selectedEstados.includes(filtro.key) ? filtro.bg : '#f5f5f5',
                                    color: selectedEstados.includes(filtro.key) ? filtro.color : '#333',
                                    border: `1px solid ${filtro.border}`,
                                    borderRadius: 8,
                                    padding: '0.5rem 1.2rem',
                                    fontWeight: 600,
                                    boxShadow: selectedEstados.includes(filtro.key) ? `0 2px 8px ${filtro.bg}66` : 'none',
                                    transition: 'all 0.2s',
                                }}
                                onClick={() => {
                                    setSelectedEstados(prev =>
                                        prev.includes(filtro.key)
                                            ? prev.filter(e => e !== filtro.key)
                                            : [...prev, filtro.key]
                                    );
                                }}
                            >
                                {filtro.label}
                            </button>
                        ))}
                    </div>
                    <div style={{ height: 'calc(100vh - 250px)' }}>
                        <Calendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            onSelectEvent={handleSelectEvent}
                            selectable
                            views={['month', 'week', 'day']}
                            defaultView="month"
                            style={{ height: 550 }}
                            components={{
                                event: CustomEvent,
                            }}
                            messages={messages}
                            eventPropGetter={(event) => ({
                                style: event.style // Usa el estilo definido en el evento
                            })}
                            dayPropGetter={(date) => {
                                const isWeekend = date.getDay() === 0 || date.getDay() === 6;
                                return {
                                    className: isWeekend ? 'bg-light' : '',
                                };
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Modal para ver detalles del turno */}
            {turnoSeleccionado && (
                <TurnoModalTaller
                    isOpen={modalIsOpen}
                    onClose={handleCloseModal}
                    turnoSeleccionado={turnoSeleccionado}
                    cargarTurnos={cargarTurnos}
                    nombre={nombre}
                    setNombre={setNombre}
                    telefono={telefono}
                    setTelefono={setTelefono}
                    motivoInactivo=""
                    setMotivoInactivo={() => { }}
                    nuevaFecha={nuevaFecha}
                    setNuevaFecha={setNuevaFecha}
                    periodicidad={periodicidad}
                    setPeriodicidad={setPeriodicidad}
                    nuevaHoraInicio={nuevaHoraInicio}
                    setNuevaHoraInicio={setNuevaHoraInicio}
                    nuevaHoraFin={nuevaHoraFin}
                    setNuevaHoraFin={setNuevaHoraFin}
                    nuevoComentario=""
                    setNuevoComentario={setNuevoComentario}
                    comentarioActualizado=""
                    cancelarActualizado=""
                    nuevoEstado={nuevoEstado}
                    setNuevoEstado={setNuevoEstado}
                    categorias={categorias}
                    categoriaSeleccionada=""
                    setCategoriaSeleccionada={() => { }}
                    servicioSeleccionado=""
                    setServicioSeleccionado={() => { }}
                    terapeutaSeleccionado=""
                    setTerapeutaSeleccionado={() => { }}
                    salaSeleccionada={salaSeleccionada}
                    setSalaSeleccionada={() => { }}
                    citasSeleccionadas={citasSeleccionadas}
                    setCitasSeleccionadas={setCitasSeleccionadas}
                    alertAsignarSala=""
                    handleUpdateText={handleUpdateText}
                    handleUpdateDate={handleUpdateDate}
                    handleInsertComment={() => { }}
                    handleNewAppointment={handleNewAppointment}
                    handleCancelar={handleCancelar}
                />

            )}
        </div>
    );
}
